export class SessionError extends Error {
  readonly code: number;

  constructor(code: number, message?: string) {
    super(message);
    this.code = code;
  }
}
